// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": () => import("/Users/tlockn/NikeDev/Nike/engineering.nike.com/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

